/**
 * Sprite mask layer.
 */
export enum SpriteMaskLayer {
  /** Mask layer 0. */
  Layer0 = 0x1,
  /** Mask layer 1. */
  Layer1 = 0x2,
  /** Mask layer 2. */
  Layer2 = 0x4,
  /** Mask layer 3. */
  Layer3 = 0x8,
  /** Mask layer 4. */
  Layer4 = 0x10,
  /** Mask layer 5. */
  Layer5 = 0x20,
  /** Mask layer 6. */
  Layer6 = 0x40,
  /** Mask layer 7. */
  Layer7 = 0x80,
  /** Mask layer 8. */
  Layer8 = 0x100,
  /** Mask layer 9. */
  Layer9 = 0x200,
  /** Mask layer 10. */
  Layer10 = 0x400,
  /** Mask layer 11. */
  Layer11 = 0x800,
  /** Mask layer 12. */
  Layer12 = 0x1000,
  /** Mask layer 13. */
  Layer13 = 0x2000,
  /** Mask layer 14. */
  Layer14 = 0x4000,
  /** Mask layer 15. */
  Layer15 = 0x8000,
  /** Mask layer 16. */
  Layer16 = 0x10000,
  /** Mask layer 17. */
  Layer17 = 0x20000,
  /** Mask layer 18. */
  Layer18 = 0x40000,
  /** Mask layer 19. */
  Layer19 = 0x80000,
  /** Mask layer 20. */
  Layer20 = 0x100000,
  /** Mask layer 21. */
  Layer21 = 0x200000,
  /** Mask layer 22. */
  Layer22 = 0x400000,
  /** Mask layer 23. */
  Layer23 = 0x800000,
  /** Mask layer 24. */
  Layer24 = 0x1000000,
  /** Mask layer 25. */
  Layer25 = 0x2000000,
  /** Mask layer 26. */
  Layer26 = 0x4000000,
  /** Mask layer 27. */
  Layer27 = 0x8000000,
  /** Mask layer 28. */
  Layer28 = 0x10000000,
  /** Mask layer 29. */
  Layer29 = 0x20000000,
  /** Mask layer 30. */
  Layer30 = 0x40000000,
  /** Mask layer 31. */
  Layer31 = 0x80000000,
  /** All mask layers. */
  Everything = 0xffffffff,
  /** None mask layer. */
  Nothing = 0x0
}
